import { render } from "./CookiesCard.vue?vue&type=template&id=6dea95b4&scoped=true"
import script from "./CookiesCard.vue?vue&type=script&lang=js"
export * from "./CookiesCard.vue?vue&type=script&lang=js"

import "./CookiesCard.vue?vue&type=style&index=0&id=6dea95b4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dea95b4"]])

export default __exports__